import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=19dc2a7a&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=19dc2a7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19dc2a7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19dc2a7a')) {
      api.createRecord('19dc2a7a', component.options)
    } else {
      api.reload('19dc2a7a', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=19dc2a7a&scoped=true&", function () {
      api.rerender('19dc2a7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2F8Ue4Qyy7Wvo/JS/comp/PopupBox.vue"
export default component.exports